import knightsConstantRedux from "../constant";
import { getOperatorValue } from "../../constants/constant";
import { getPriceCurrency } from "../../constants/utility";
const initialCustomer = {
  draftInvoiceList: [],
  draftInvoiceObj: {
    product: [],
    barcode: "",
    customer_id: 1,
    customer_label: "Cash Customer / 0",
    customer_first_name: "Cash",
    customer_last_name: "Customer",
    discount: { value: 0, currency: "$" },
    debt: false,
    state: "",
    insert_date: null,
    emp_id: "",
    name: "",
    invoice_date: null,
    total_price: { value: 0, currency: "$" },
    remind_price: { value: 0, currency: "$" },
    paid_total_price: [{ value: 0, currency: "$" }],
    onlineOrder: false,
    return_price: [
      {
        value: 0,
        currency: "$",
      },
      {
        value: 0,
        currency: "LBP",
      },
    ],
  },
  customerList: [],
  editCustomer: {
    phone_number: {},
  },
};
const customer = (state = initialCustomer, action, root) => {
  /*****************Invoice Draft*****************/
  switch (action.type) {
    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE:
      return {
        ...state,
        draftInvoiceObj: { ...action.payload.draftInvoice },
      };
    case knightsConstantRedux.SET_CUSTOMER_INVOICE_LIST:
      return {
        ...state,
        draftInvoiceList: [...action.payload.draftInvoiceList],
      };
    case knightsConstantRedux.SET_NEW_DRAFT_INVIOCE_TO_LIST:
      let draftInvoiceList = state.draftInvoiceList;
      if (
        !state.draftInvoiceList.find(
          (inv) => inv.id === action.payload.draftInvoice.id
        )
      ) {
        draftInvoiceList = [...draftInvoiceList, action.payload.draftInvoice];
      }
      return {
        ...state,
        draftInvoiceList: draftInvoiceList,
        draftInvoiceObj: { ...action.payload.draftInvoice },
      };
    case knightsConstantRedux.DELETE_DRAFT_CUSTOMER_INVOICE:
      return {
        ...state,
        draftInvoiceList: state.draftInvoiceList.filter(
          (di) => di.id !== action.payload.draftInvoiceId
        ),
      };
    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PROPERTY:
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          [action.payload.property]: action.payload.value,
        },
      };
    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_PROPERTY:
      let product = state.draftInvoiceObj.product;
      let index = product.findIndex((pro) => pro.id === action.payload.id);
      if (action.payload.priceCurrencyType) {
        product[index][action.payload.property].value = action.payload.value;
      } else {
        product[index][action.payload.property] = action.payload.value;
      }

      // product[index]["total_price"] = {};
      const priceVal = parseFloat(product[index]?.price?.value) || 0;
      const qtyVal = parseFloat(product[index]?.qty) || 0;
      const discVal = parseFloat(product[index]?.discount) || 0;
      product[index]["total_price"].value = priceVal * qtyVal - discVal;
      // if (product[index].amount_type === "unit") {
      //   // let cur = product[index]["total_price"].currency;
      //   product[index]["total_price"] = {};
      //   product[index]["total_price"].value =
      //     parseFloat(product[index].price.value) *
      //       parseInt(product[index].qty) -
      //     product[index].discount;
      //   // product[index]["total_price"].currency = cur;
      // } else {
      //   let cur = product[index]["total_price"].currency;
      //   product[index]["total_price"] = {};
      //   product[index]["total_price"].value =
      //     parseFloat(product[index].price.value) - product[index].discount;
      //   product[index]["total_price"].currency = cur;
      // }
      let price = 0;

      state.draftInvoiceObj.product.forEach((pro) => {
        if (pro.total_price.currency === "LBP") {
          price =
            price +
            getPriceCurrency(
              "LBP",
              pro.total_price.value,
              root.appSetting?.coins || []
            );
        } else {
          price = price + parseFloat(pro.total_price.value);
        }
      });
      state.draftInvoiceObj.remind_price = {};
      state.draftInvoiceObj.remind_price.value = price;

      for (const paidPrice of state.draftInvoiceObj.paid_total_price) {
        if (paidPrice.currency !== "$") {
          state.draftInvoiceObj.remind_price.value -= getPriceCurrency(
            "LBP",
            parseFloat(paidPrice.value),
            root.appSetting?.coins || []
          );
        } else {
          state.draftInvoiceObj.remind_price.value -= paidPrice.value;
        }
      }
      state.draftInvoiceObj.remind_price.currency = "$";

      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          product: product,
          total_price: { value: price, currency: "$" },
          //   remind_price: state.draftInvoiceObj.remind_price,
        },
      };
    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_DISCOUNT_PROPERTY:
      let discountTotalPirce = 0;
      state.draftInvoiceObj.product.forEach((pro) => {
        discountTotalPirce = discountTotalPirce + pro.total_price.value;
      });
      let discount = state.draftInvoiceObj.discount;
      discountTotalPirce = discountTotalPirce - discount.value;
      state.draftInvoiceObj.remind_price.value = discountTotalPirce;
      for (let paidPrice of state.draftInvoiceObj.paid_total_price) {
        if (
          paidPrice.currency !== root.appSetting?.main_currency.value ||
          "$"
        ) {
          let currencyCoin = root.appSetting?.coins.find(
            (co) => co.value === paidPrice.currency
          );
          state.draftInvoiceObj.remind_price.value -= getOperatorValue(
            paidPrice.value,
            currencyCoin.operator,
            currencyCoin.price
          );
        } else {
          state.draftInvoiceObj.remind_price.value -= paidPrice.value;
        }
      }
      state.draftInvoiceObj.remind_price.currency = "$";

      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          total_price: {
            value: discountTotalPirce,
            currency: root.appSetting?.main_currency.value || "$",
          },
          discount: discount,
          remind_price: state.draftInvoiceObj.remind_price,
        },
      };
    case knightsConstantRedux.RESET_DRAFT_CUSTOMER_INVOICE:
      const newstate = JSON.parse(
        JSON.stringify(initialCustomer.draftInvoiceObj)
      );
      // newstate.name = action.payload.id;
      newstate.total_price = {
        value: 0,
        currency: root.appSetting?.main_currency.value || "$",
      };
      newstate.product = [];
      return {
        ...state,
        draftInvoiceObj: { ...newstate },
      };
    case knightsConstantRedux.DELETE_DRAFT_INVOICE_PRODUCT:
      let deletedProductIndex = state.draftInvoiceObj.product.findIndex(
        (pro) => pro.id === action.payload.product.id
      );
      state.draftInvoiceObj.product.splice(deletedProductIndex, 1);
      let new_total_price;
      if (action.payload.product.total_price.currency === "LBP") {
        new_total_price = getPriceCurrency(
          "LBP",
          parseFloat(action.payload.product.total_price.value),
          root.appSetting?.coins
        );
      } else {
        new_total_price = parseFloat(action.payload.product.total_price.value);
      }
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          product: state.draftInvoiceObj.product,
          total_price: {
            ...state.draftInvoiceObj["total_price"],
            value: state.draftInvoiceObj.total_price.value - new_total_price,
          },
          remind_price: {
            ...state.draftInvoiceObj["total_price"],
            value: state.draftInvoiceObj.total_price.value - new_total_price,
          },
        },
      };
    case knightsConstantRedux.ADD_DRAFT_INVOICE_PRODUCT:
      let productObjectIndex = state.draftInvoiceObj.product.findIndex(
        (pro) => action.payload.product.id === pro.id
      );

      if (
        productObjectIndex !== -1 &&
        action.payload.product.amount_type !== "unit"
      ) {
        return {
          ...state,
          draftInvoiceObj: {
            ...state.draftInvoiceObj,
            product: state.draftInvoiceObj.product,
            total_price: state.draftInvoiceObj.total_price,
            remind_price: state.draftInvoiceObj.total_price,
          },
        };
      }
      if (productObjectIndex !== -1) {
        action.payload.product.discount =
          state.draftInvoiceObj.product[productObjectIndex].discount;
        if (
          state.draftInvoiceObj.product[productObjectIndex].qty <
          action.payload.product.maxQty
        )
          state.draftInvoiceObj.product[productObjectIndex].qty =
            parseInt(action.payload.product.qty) +
            parseInt(state.draftInvoiceObj.product[productObjectIndex].qty);
      } else {
        state.draftInvoiceObj.product = [
          ...state.draftInvoiceObj.product,
          action.payload.product,
        ];
      }
      if (!action.payload.product.new_service) {
        if (action.payload.product.price.currency === "LBP") {
          state.draftInvoiceObj.total_price.value += getPriceCurrency(
            "LBP",
            parseFloat(action.payload.product.total_price.value),
            root.appSetting?.coins
          );
        } else {
          state.draftInvoiceObj.total_price.value += parseFloat(
            action.payload.product.total_price.value
          );
          state.draftInvoiceObj.total_price.currency = "$";
        }
      } else {
        let productObjectIndex = state.draftInvoiceObj.product.findIndex(
          (pro) => action.payload.product.id === pro.id
        );
        if (action.payload.product.price.currency === "LBP") {
          state.draftInvoiceObj.product[productObjectIndex].total_price = {
            currency: "LBP",
            value: parseFloat(action.payload.product.price.value),
          };

          state.draftInvoiceObj.total_price.value =
            state.draftInvoiceObj.total_price.value +
            getPriceCurrency(
              "LBP",
              parseFloat(action.payload.product.price.value),
              root.appSetting?.coins
            );
        } else if (action.payload.product.price.currency === "$") {
          state.draftInvoiceObj.product[productObjectIndex].total_price = {
            currency: "$",
            value: parseFloat(action.payload.product.price.value),
          };

          state.draftInvoiceObj.total_price.value =
            state.draftInvoiceObj.total_price.value +
            parseFloat(action.payload.product.price.value);
        }
      }
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          product: state.draftInvoiceObj.product,
          total_price: state.draftInvoiceObj.total_price,
          remind_price: state.draftInvoiceObj.total_price,
        },
      };
    case knightsConstantRedux.SET_DRAFT_CUTOMER_INVOICE_DISCOUNT_TYPE:
      let discountType = { ...state.draftInvoiceObj.discount };
      discountType.currency = action.payload.discountType;
      let discountTypeTotalPirce = 0;
      state.draftInvoiceObj.product.forEach((pro) => {
        if (pro.total_price.currency !== root.appSetting?.main_currency.value) {
          let totalProCurrency = root.appSetting?.coins.find(
            (co) => co.value === pro.total_price.currency
          );
          discountTypeTotalPirce += getOperatorValue(
            pro.total_price.value,
            totalProCurrency.operator,
            totalProCurrency.price
          );
        } else {
          discountTypeTotalPirce += pro.total_price.value;
        }
      });
      //
      let currencyDiscountType = root.appSetting?.coins.find(
        (co) => co.value === discountType.currency
      );
      discountTypeTotalPirce =
        discountTypeTotalPirce -
        getOperatorValue(
          discountType.value,
          currencyDiscountType.operator,
          currencyDiscountType.price
        );
      state.draftInvoiceObj.total_price.value = discountTypeTotalPirce;

      for (let i = 0; i < state.draftInvoiceObj.return_price?.length; i++) {
        const returnPriceDis = state.draftInvoiceObj.return_price[i];
        if (returnPriceDis.currency !== root.appSetting?.main_currency.value) {
          let returnPriceDisCurr = root.appSetting?.coins.find(
            (co) => co.value === returnPriceDis.currency
          );
          discountTypeTotalPirce =
            discountTypeTotalPirce +
            getOperatorValue(
              returnPriceDis.value,
              returnPriceDisCurr.operator,
              returnPriceDisCurr.price
            );
        } else {
          discountTypeTotalPirce =
            discountTypeTotalPirce + returnPriceDis.value;
        }
      }

      state.draftInvoiceObj.remind_price.value = discountTypeTotalPirce;

      for (let paidPrice of state.draftInvoiceObj.paid_total_price) {
        if (paidPrice.currency !== root.appSetting?.main_currency.value) {
          let priceCurrency = root.appSetting?.coins.find(
            (co) => co.value === paidPrice.currency
          );
          state.draftInvoiceObj.remind_price.value -= getOperatorValue(
            paidPrice.value,
            priceCurrency.operator,
            priceCurrency.price
          );
        } else {
          state.draftInvoiceObj.remind_price.value -= paidPrice.value;
        }
      }
      state.draftInvoiceObj.remind_price.currency = "$";
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          total_price: {
            value: state.draftInvoiceObj.total_price.value,
            currency: "$",
          },
          discount: discountType,
          remind_price: state.draftInvoiceObj.remind_price,
        },
      };
    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_DISCOUNT_PROPERTY:
      let discountPrice = parseFloat(state.draftInvoiceObj.discount.value);
      let newDiscountPrice = parseFloat(action.payload.value);
      const restPrice = { ...state.draftInvoiceObj.remind_price };
      if (isNaN(newDiscountPrice)) {
        newDiscountPrice = 0;
      }
      if (isNaN(discountPrice)) {
        discountPrice = 0;
      }

      if (state.draftInvoiceObj.discount.currency === "LBP") {
        discountPrice = parseFloat((parseFloat(discountPrice / action.payload.LBPRate).toFixed(2)));
        newDiscountPrice = parseFloat((parseFloat(newDiscountPrice / action.payload.LBPRate).toFixed(2)))
      }
      state.draftInvoiceObj.total_price.value += discountPrice;
      state.draftInvoiceObj.total_price.value -= newDiscountPrice;
      restPrice.value += discountPrice;
      restPrice.value -= newDiscountPrice;

      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          total_price: {
            value: parseFloat(state.draftInvoiceObj.total_price.value),
            currency: "$",
          },
          discount: {
            value: action.payload.value,
            currency: state.draftInvoiceObj.discount.currency,
          },
          remind_price: restPrice,
        },
      };
    case knightsConstantRedux.SET_DRAFT_CUTOMER_INVOICE_PAID_PRICE:
      let actionPrice = action.payload.price || 0;
      if (action.payload.priceType === "$") {
        actionPrice = parseFloat(actionPrice.toFixed(2));
      }

      if (action.payload.type === "return") {
        let returnindexPaidTotal;
        if (state.draftInvoiceObj.return_price) {
          returnindexPaidTotal = state.draftInvoiceObj.return_price.findIndex(
            (ptp) => ptp.currency === action.payload.priceType
          );
          if (returnindexPaidTotal === -1) {
            state.draftInvoiceObj.return_price = [
              ...state.draftInvoiceObj.return_price,
              {
                value: actionPrice,
                currency: action.payload.priceType,
              },
            ];
          } else {
            state.draftInvoiceObj.return_price[returnindexPaidTotal] = {
              value: actionPrice,
              currency: action.payload.priceType,
            };
          }
        } else {
          state.draftInvoiceObj.return_price = {
            ...initialCustomer.draftInvoiceObj.return_price,
          };
        }
      }
      if (action.payload.type === "paid") {
        let indexPaidTotal = state.draftInvoiceObj.paid_total_price.findIndex(
          (ptp) => ptp.currency === action.payload.priceType
        );
        if (indexPaidTotal === -1) {
          state.draftInvoiceObj.paid_total_price = [
            ...state.draftInvoiceObj.paid_total_price,
            {
              value: actionPrice,
              currency: action.payload.priceType,
            },
          ];
        } else {
          state.draftInvoiceObj.paid_total_price[indexPaidTotal] = {
            value: actionPrice,
            currency: action.payload.priceType,
          };
        }
      }

      state.draftInvoiceObj.remind_price = {
        ...state.draftInvoiceObj.total_price,
      };
      for (let paidPrice of state.draftInvoiceObj.paid_total_price) {
        if (paidPrice.currency === "LBP") {
          state.draftInvoiceObj.remind_price.value -=
            paidPrice.value / parseFloat(action.payload.exchange);
        } else {
          state.draftInvoiceObj.remind_price.value -= paidPrice.value;
        }
      }
      if (state.draftInvoiceObj.return_price) {
        for (let retunrPrice of state.draftInvoiceObj.return_price) {
          if (retunrPrice.currency === "LBP") {
            state.draftInvoiceObj.remind_price.value +=
              retunrPrice.value / parseFloat(action.payload.exchange);
          } else {
            state.draftInvoiceObj.remind_price.value += retunrPrice.value;
          }
        }
      }
      if (action.payload.type === "closeConfirmation") {
        state.draftInvoiceObj.remind_price.value =
          state.draftInvoiceObj.total_price.value;
      }
      state.draftInvoiceObj.remind_price.currency = "$";
      state.draftInvoiceObj.remind_price.value = parseFloat(
        state.draftInvoiceObj.remind_price.value.toFixed(2)
      );
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          paid_total_price: state.draftInvoiceObj.paid_total_price,
          remind_price: state.draftInvoiceObj.remind_price,
        },
      };
    case knightsConstantRedux.REST_INVOICE_FUND:
      let restTotlPrice = 0;
      state.draftInvoiceObj.product.forEach((pro) => {
        if (pro.total_price.currency === "LBP") {
          restTotlPrice =
            restTotlPrice +
            getPriceCurrency(
              "LBP",
              pro.total_price.value,
              root.appSetting?.coins || []
            );
        } else {
          restTotlPrice = restTotlPrice + parseFloat(pro.total_price.value);
        }
      });
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          remind_price: {
            currency: "$",
            value: 0,
          },
          discount: { value: 0, currency: "$" },
          debt: false,
          paid_total_price: [{ value: 0, currency: "$" }],
          total_price: { value: 0, currency: "$" },
          product: [],
          return_price: [
            {
              value: 0,
              currency: "$",
            },
            {
              value: 0,
              currency: "LBP",
            },
          ],
        },
      };
    case knightsConstantRedux.REST_INVOICE_FUND_WITHOUT_PRODUCT:
      let restTotlPriceWithoutProduct = 0;
      state.draftInvoiceObj.product.forEach((pro) => {
        if (pro.total_price.currency === "LBP") {
          restTotlPriceWithoutProduct =
            restTotlPriceWithoutProduct +
            getPriceCurrency(
              "LBP",
              pro.total_price.value,
              root.appSetting?.coins || []
            );
        } else {
          restTotlPriceWithoutProduct =
            restTotlPriceWithoutProduct + parseFloat(pro.total_price.value);
        }
      });
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          remind_price: {
            currency: "$",
            value: restTotlPriceWithoutProduct,
          },
          discount: { value: 0, currency: "$" },
          debt: false,
          paid_total_price: [{ value: 0, currency: "$" }],
          total_price: { value: restTotlPriceWithoutProduct, currency: "$" },
          return_price: [
            {
              value: 0,
              currency: "$",
            },
            {
              value: 0,
              currency: "LBP",
            },
          ],
        },
      };

    case knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_NAME:
      return {
        ...state,
        draftInvoiceObj: {
          ...state.draftInvoiceObj,
          name: action.payload.name,
        },
      };

    default:
      return state;
  }
};
export default customer;
